import clsx from 'clsx';
import Image from 'next/image';
import Link from 'next/link';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSelector from '../language-selector/language-selector.component';
import { useOrgContext } from '../org-context/org-context-provider';

const HeaderLogo = (): ReactElement => {
  const { config } = useOrgContext();
  const { t } = useTranslation();
  return (
    <Link href={config.companyUrl} className={'min-w-14 max-w-56'}>
      <Image
        priority={true}
        src={config.branding.logoUrl}
        alt={t('aria.logoAlt', { orgName: config.name })}
        width={config.branding.logoWidth}
        height={config.branding.logoHeight}
      />
    </Link>
  );
};

export interface HeaderProps {
  className?: string;
}

const DefaultHeader = ({ className }: HeaderProps): ReactElement => (
  <header
    className={clsx('z-10 border border-b-black border-opacity-10', className)}
  >
    <div className={'h-1 bg-primary-color'} aria-hidden={'true'} />
    <nav
      className={
        'outer-margin flex h-20 items-center justify-between desktop:h-24'
      }
      aria-label={'Global'}
    >
      <HeaderLogo />
      <div className={'p-3'}>
        <LanguageSelector buttonClassName={'text-black'} />
      </div>
    </nav>
  </header>
);

export default DefaultHeader;
